export const PREVIEW_CLIENT_SECTIONS = [
  {
    key: 'mobile',
    title: 'Mobile',
    clients: [
      {
        id: 'android16_gmailapp_pixel10_lm',
        client: 'Gmail App Pixel 10',
        os: 'Android 16',
        category: 'mobile',
        label: 'Gmail App',
        subtitle: 'Android · Light',
        icon: 'gmail',
      },
      {
        id: 'iphone16gmail_26',
        client: 'Gmail App iPhone 16',
        os: 'iOS 26',
        category: 'mobile',
        label: 'Gmail App',
        subtitle: 'iOS · Light',
        icon: 'gmail',
      },
      {
        id: 'iphone17pro_26',
        client: 'iPhone 17 Pro',
        os: 'iOS 26',
        category: 'mobile',
        label: 'Apple Mail',
        subtitle: 'iOS 26',
        icon: 'ios',
      },
      {
        id: 'iphone13ol_15',
        client: 'Outlook App iPhone 13',
        os: 'iOS 15',
        category: 'mobile',
        label: 'Outlook App iPhone 13',
        subtitle: 'iOS 15',
        icon: 'outlook',
      },
      {
        id: 'android12_outlookapp_pixel6_lm',
        client: 'Outlook App Pixel 6',
        os: 'Android 12',
        category: 'mobile',
        label: 'Outlook App Pixel 6',
        subtitle: 'Android 12',
        icon: 'outlook',
      },
    ],
  },
  {
    key: 'desktop',
    title: 'Desktop',
    clients: [
      {
        id: 'm365_w11_lm_dt',
        client: 'Outlook Microsoft 365',
        os: 'Windows 11',
        category: 'desktop',
        label: 'Outlook Microsoft 365',
        subtitle: 'Windows 11 desktop',
        icon: 'outlook',
      },
      {
        id: 'applemail16',
        client: 'Apple Mail 16',
        os: 'macOS 13',
        category: 'desktop',
        label: 'Apple Mail',
        subtitle: 'macOS 13',
        icon: 'apple',
      },
      {
        id: 'm365_mac13_lm_dt',
        client: 'Outlook Microsoft 365',
        os: 'macOS 13',
        category: 'desktop',
        label: 'Outlook Microsoft 365',
        subtitle: 'macOS 13 desktop',
        icon: 'outlook',
      },
    ],
  },
  {
    key: 'web',
    title: 'Web',
    clients: [
      {
        id: 'gmailcom-lm_chrcurrent_win10',
        client: 'Gmail.com',
        os: 'Windows 10',
        category: 'web',
        label: 'Gmail Web',
        subtitle: 'Desktop · Light',
        icon: 'gmail',
      },
      {
        id: 'gmailcom-dm_chrcurrent_win10',
        client: 'Gmail.com',
        os: 'Windows 10 (Dark Mode)',
        category: 'web',
        label: 'Gmail Web',
        subtitle: 'Desktop · Dark',
        icon: 'gmail',
      },
      {
        id: 'outlookcom-lm_chrcurrent_win10',
        client: 'Outlook.com',
        os: 'Windows 10',
        category: 'web',
        label: 'Outlook Web',
        subtitle: 'Chrome on Windows 10',
        icon: 'outlook',
      },
      {
        id: 'yahoocom-lm_chrcurrent_win10',
        client: 'Yahoo.com',
        os: 'Windows 10',
        category: 'web',
        label: 'Yahoo Mail',
        subtitle: 'Chrome on Windows 10',
        icon: 'yahoo',
      },
    ],
  },
  {
    key: 'dark',
    title: 'Dark Mode',
    clients: [
      {
        id: 'android16_gmailapp_pixel10_dm',
        client: 'Gmail App Pixel 10',
        os: 'Android 16 (Dark Mode)',
        category: 'mobile',
        label: 'Gmail App',
        subtitle: 'Android · Dark',
        icon: 'gmail',
      },
      {
        id: 'iphone16gmail_26_dm',
        client: 'Gmail App iPhone 16',
        os: 'iOS 26 (Dark Mode)',
        category: 'mobile',
        label: 'Gmail App',
        subtitle: 'iOS · Dark',
        icon: 'gmail',
      },
      {
        id: 'iphone17pro_26_dm',
        client: 'iPhone 17 Pro',
        os: 'iOS 26 (Dark Mode)',
        category: 'mobile',
        label: 'Apple Mail',
        subtitle: 'iOS 26 · Dark',
        icon: 'ios',
      },
    ],
  },
];

export const PREVIEW_CLIENTS = PREVIEW_CLIENT_SECTIONS.flatMap((section) =>
  section.clients
);

export const PREVIEW_CLIENTS_BY_ID = Object.fromEntries(
  PREVIEW_CLIENTS.map((client) => [client.id, client])
);
